export default __webpack_public_path__ + "static/trance01-89d3f752af4b22508e6520ab0dfbb1d9.webp";